import type { CharacterDetail } from '@/mocks/characterDetail';

interface ProfileProps {
  detail?: CharacterDetail;
}

export default function Profile({ detail }: ProfileProps) {
  const items = detail?.profile ?? [];

  return (
    <section className="bg-background-50 py-16 md:py-28">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="reveal mb-12 md:mb-16">
          <div className="mb-6 flex items-center gap-3">
            <span className="text-[11px] tracking-[0.34em] text-primary-600 uppercase">
              Character
            </span>
            <span className="h-px w-8 bg-primary-300"></span>
            <span className="text-[11px] tracking-[0.28em] text-foreground-400 uppercase">
              NOMO 灵档案
            </span>
          </div>
          <h2 className="font-heading text-3xl tracking-[0.06em] text-foreground-950 md:text-4xl">
            角色档案
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((item, index) => (
            <div
              key={item.label}
              className="reveal rounded-lg border border-background-200/70 bg-background-100 px-5 py-6"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <p className="text-[11px] tracking-[0.2em] text-foreground-400 uppercase">
                {item.label}
              </p>
              <p className="mt-3 text-base leading-relaxed text-foreground-800">{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}